import React from 'react';
import { MarketingArticle } from './marketingArticle.jsx';
import heroImage from '../pictures/AI agent bought handbag.webp';
import apiImage from '../pictures/API.webp';
import recordImage from '../pictures/Library.avif';

export function PromptSecurity() {
  return (
    <MarketingArticle
      title="AI Prompt Security"
      kicker="Trust for agents"
      description="As AI agents take action for people and companies, organizations need proof of what was requested, approved, and executed."
      path="/overview"
      heroImage={heroImage}
      heroAlt="AI agent shopping concept"
      primaryAction={{ to: '/contact', label: 'Discuss AI trust' }}
      secondaryAction={{ to: '/publications', label: 'See papers' }}
      sections={[
        {
          tag: 'Business risk',
          title: 'AI decisions need a trustworthy record.',
          paragraphs: [
            'When an AI agent buys, approves, reports, or sends messages, the organization needs to know which prompt caused the action and whether it was changed before execution.',
            'A secure prompt proxy can create an independent record for audits, disputes, compliance, and customer confidence.',
          ],
        },
        {
          tag: 'How it helps',
          title: 'Back-Step Blockchain becomes the evidence layer.',
          image: apiImage,
          imageAlt: 'API concept',
          paragraphs: [
            'Prompts, responses, approvals, and agent actions can be anchored as tamper-resistant records. The AI system stays flexible, while the surrounding trust layer remains verifiable.',
            'This is especially useful for regulated industries, customer service, procurement, and autonomous workflows where hidden instruction changes create real liability.',
          ],
        },
        {
          tag: 'Outcome',
          title: 'Customers and managers can inspect the trail.',
          image: recordImage,
          imageAlt: 'Record library',
          paragraphs: [
            'The goal is not to slow AI down. It is to make AI safe enough for important work by proving who asked for what and when.',
            'That proof can support internal review, external audits, and stronger customer trust.',
          ],
        },
      ]}
    />
  );
}
